/**
 * This file was auto-generated by Fern from our API Definition.
 */

export const TruvityEnvironment = {
    Default: 'https://api.truvity.com',
} as const;

export type TruvityEnvironment = typeof TruvityEnvironment.Default;
